import {FC, Fragment, ReactNode} from 'react';
import {CircularProgress, Stack} from '@mui/material';

interface Props {
  children: ReactNode;
  isLoading: boolean;
}

export const FallbackWithChildren: FC<Props> = ({children, isLoading}) => {
  if (isLoading) {
    return (
      <Stack minHeight="100%" alignItems="center" justifyContent="center" flexGrow={1}>
        <CircularProgress />
      </Stack>
    );
  }
  return <Fragment>{children}</Fragment>;
};
